const environments = [
    { name: 'local', predicate: ({ hostname }: Location) => hostname === 'localhost' },
    { name: 'stm', predicate: ({ host }: Location) => host.includes(`-stm.utv.`) },
    { name: 'dev', predicate: ({ host }: Location) => host.includes(`.utv.`) },
    { name: 'test', predicate: ({ host }: Location) => host.includes(`.test.`) },
    { name: 'prod', predicate: () => true },
];

export function runtimeEnvironment(): string {
    const env = environments.find(e => e.predicate(window.location));
    if (!env) throw new Error('Unable to determine runtime environment');
    return env.name;
}

/**
 * Reads a raw value from the bundled process.env.config, with the same precedence as
 * @/config: override, active environment, then base. Avoids importing from @/config to
 * prevent circular deps.
 */
export function getRawConfigValue(key: string): string | undefined {
    const raw = process.env.config as Record<string, Record<string, string>> | undefined;
    if (!raw) return undefined;
    const env = sessionStorage.getItem('apiEnvironment') || runtimeEnvironment();
    return raw['override']?.[key] ?? raw[env]?.[key] ?? raw['base']?.[key];
}
